const Backbone = require('backbone');
var FreeShippingMessageView = Backbone.View.extend({
	initialize: function() {
		this.listenTo(Backbone, 'finish:clicked', this.render);
		this.listenTo(Backbone, 'finish:hover', this.render);
		this.listenTo(Backbone, 'customerLocation:changed', this._toggleShippingMessage.bind(this));
		this.$shippingMessage = $('.js-item-ship-cost');
		this.isQuickShip = false;
	},
	el: '.js-freeshipping-message',

	render: function(data) {
		const shippingMessage = data.shippingMessage || data.freeShippingMessage || '';
		this.$el.html(shippingMessage);
	},
	_toggleShippingMessage: function(customerLocation, isQuickShip = false) {
		if (customerLocation && customerLocation.hasOwnProperty('highCost') && !customerLocation.highCost && !isQuickShip) {
			this.$shippingMessage.removeClass('hide');
		} else {
			this.$shippingMessage.addClass('hide');
		}
	}
});

module.exports = FreeShippingMessageView;
